/**
 * Created by smallking on 2018/12/4.
 */
export default {
  log(str) {
    if (process.env.LOG) {
      // console.log(str);
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/myLog.js